import type { JSONDocNode } from './JSONDocNode';
import type { JSONNode } from './JSONNode';

/**
 * Extracts all existing URLs from the document by recursively
 * traversing the document tree. This prevents duplicate URLs from being added.
 *
 * @param doc - The editor document to traverse (from requestDocument callback)
 * @returns A Set of all URLs found within the document
 */
export const getExistingUrlsFromDocument = (doc: JSONDocNode): Set<string> => {
	const existingUrls = new Set<string>();
	const traverseNode = (node: JSONNode): void => {
		if (!node || typeof node !== 'object') {
			return;
		}

		// Check if this node contains a URL
		if (node.type === 'inlineCard' && node.attrs && typeof node.attrs === 'object') {
			const url = (node.attrs as { url?: string }).url;
			if (url) {
				existingUrls.add(url);
			}
		}

		// Recursively traverse child nodes
		if (node.content && Array.isArray(node.content)) {
			node.content.forEach((childNode) => {
				if (childNode) {
					traverseNode(childNode);
				}
			});
		}
	};

	if (doc.content && Array.isArray(doc.content)) {
		doc.content.forEach((node) => traverseNode(node));
	}

	return existingUrls;
};
